import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

export default {
  methods: {
    onDeleteSession (event) {
      this.$set(this.informationDialogData, 'message', this.$t('base/session.confirm_delete'))
      this.$set(this.informationDialogData, 'cancelText', this.$t('base.cancel'))
      this.$set(this.informationDialogData, 'confirmText', this.$t('base.confirm'))
      this.$set(this.informationDialogData, 'title', this.$t('base/session.delete'))
      this.$set(this.informationDialogData, 'callback', async () => await this.onSessionDeleteCallback(event))
      this.$set(this.informationDialogData, 'show', true)
    },

    async onSessionDeleteCallback (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.session || {}

        if (id) {
          await api('base').delete(`/session/${id}`)

          this.$set(this.informationDialogData, 'show', false)
          // Refresh table data
          fetchData?.()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
